module.exports = __webpack_public_path__ + "media/images/login-bkg-alt-2be837b6dd2bbfcc5b038524d3f41b7d.jpg";